import React from 'react';
import { motion } from 'framer-motion';

export const NotifyBuildIcon: React.FC<{ isActive: boolean }> = ({
	isActive,
}) => {
	return (
		<motion.svg
			animate={isActive ? { scale: 1.15 } : null}
			width="100%"
			height="100%"
			viewBox="0 0 64 64"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<circle cx="32" cy="32" r="32" fill="white" />
			<rect
				x="13.75"
				y="10.7812"
				width="36.5"
				height="46.5"
				rx="3.25"
				stroke="#F27C00"
				stroke-width="1.5"
			/>
			<path
				d="M41.8794 10.0489V8.86757C41.8778 8.61637 41.7769 8.37599 41.5987 8.19892C41.4206 8.02185 41.1796 7.92246 40.9284 7.92247H37.8154C37.5868 7.92096 37.3661 7.83812 37.1929 7.68876C37.0198 7.53941 36.9054 7.33329 36.8703 7.10732C36.6666 5.96464 36.0672 4.93008 35.1774 4.18485C34.2875 3.43963 33.1638 3.03125 32.0031 3.03125C30.8424 3.03125 29.7186 3.43963 28.8288 4.18485C27.9389 4.93008 27.3396 5.96464 27.1358 7.10732C27.102 7.3328 26.9889 7.53881 26.8167 7.68826C26.6445 7.8377 26.4246 7.92076 26.1966 7.92247H23.0778C22.8337 7.92846 22.6013 8.02809 22.4286 8.20072C22.256 8.37336 22.1564 8.60578 22.1504 8.84985V14.3019C22.152 14.5531 22.2528 14.7935 22.431 14.9705C22.6092 15.1476 22.8502 15.247 23.1014 15.247H40.9284C41.1796 15.247 41.4206 15.1476 41.5987 14.9705C41.7769 14.7935 41.8778 14.5531 41.8794 14.3019V10.0489Z"
				fill="#F27C00"
			/>
			<path
				d="M32.0032 10.3557C33.0242 10.3557 33.852 9.53325 33.852 8.51868C33.852 7.50411 33.0242 6.68164 32.0032 6.68164C30.9821 6.68164 30.1543 7.50411 30.1543 8.51868C30.1543 9.53325 30.9821 10.3557 32.0032 10.3557Z"
				fill="white"
			/>
			<path
				d="M29 24.0312H21V32.0312H29V24.0312Z"
				stroke="#F27C00"
				stroke-width="1.5"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M42 28.0312H33"
				stroke="#F27C00"
				stroke-width="1.5"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M23 27.091L25.4454 29.5365L30.9507 24.0312"
				stroke="#F27C00"
				stroke-width="1.5"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M29 38.0312H21V46.0312H29V38.0312Z"
				stroke="#F27C00"
				stroke-width="1.5"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M42 42.0312H33"
				stroke="#F27C00"
				stroke-width="1.5"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
			<path
				d="M23 41.091L25.4454 43.5365L30.9507 38.0312"
				stroke="#F27C00"
				stroke-width="1.5"
				stroke-linecap="round"
				stroke-linejoin="round"
			/>
		</motion.svg>
	);
};
